import { render } from "./returns.vue?vue&type=template&id=0c35c85b"
import script from "./returns.vue?vue&type=script&lang=js"
export * from "./returns.vue?vue&type=script&lang=js"

import "./returns.vue?vue&type=style&index=0&id=0c35c85b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__